import script from "./PayCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PayCenter.vue?vue&type=script&setup=true&lang=js"

import "./PayCenter.vue?vue&type=style&index=0&id=28345e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28345e6e"]])

export default __exports__